<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Primeiro Acesso
        </v-card-title>
        <v-container fluid>
          <v-form
            @submit.prevent=""
            ref="formPassword"
            v-model="valid"
            lazy-validation
          >
          <v-text-field
            :rules="rules"
            autofocus
            label="Nova Senha"
            v-model="newPassword"
            :type="showPassword ? 'text' : 'password'"
            maxlength="100"
            required
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>

           <v-text-field
            label="Confirmar Nova Senha"
            v-model="confirmNewPassword"
            :type="showPassword ? 'text' : 'password'"
            maxlength="100"
            v-on:keyup.enter="alterPassword"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
       
          <div v-if="newPassword !== confirmNewPassword" class="message-password v-messages error--text">Senhas não coincidem</div>
         
           </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="validate"
          >
            Alterar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data: () => ({
      showPassword: false,
      confirmNewPassword: null,
      valid: true,
      rules: [
        v => !!v || 'Informação obrigatória',
        v => (v && v.length > 6) || 'Senha deve conter no mínimo 6 caracteres',
        v => /[0-9]/.test(v) || 'Senha deve conter no mínimo 1 número',
        v => /[a-z]/.test(v) || 'Senha deve conter no mínimo 1 letra'
      ]
    }),
    props: {
      showModalAccessProp: false,
      newPasswordProp: null
    },
    methods: {
      validate () {
        if (this.$refs.formPassword.validate() && this.newPassword === this.confirmNewPassword) {
          this.alterPassword()
        }
      },
      async alterPassword () {
        this.$emit('alter-password')
      }
    },
    computed: {
      newPassword: {
        get () {
          return this.newPasswordProp
        },
        set (value) {
          this.$emit('update:newPasswordProp', value)
        }
      },
      show: {
        get () {
          return this.showModalAccessProp
        },
        set (value) {
          this.$emit('update:showModalAccessProp', value)
        }
      }
    }
  }
</script>

<style scoped>
  .message-password {
    margin-top: -17px;
    margin-left: 33px; 
  }
</style>


// WEBPACK FOOTER //
// src/components/modals/FirstAccessModal.vue